import styled, { css } from 'styled-components';
import { dynamicFontSize, fontFamilyHeading } from './helpers/mixins';

export const Heading = styled.h1`
  ${fontFamilyHeading};
  ${dynamicFontSize(22, 36)};
  font-weight: normal;
  margin: ${props => (props.margin ? props.margin : '0 0 1rem')};
  text-align: ${props => (props.center ? 'center' : 'left')};
  font-variant-ligatures: no-common-ligatures;

  // set min-height to 1.3333em to avoid jumping
  min-height: 1.3333em;

  ${props =>
    props.big &&
    css`
      ${dynamicFontSize(32, 52)};
    `};

  ${props =>
    props.textAlign &&
    css`
      text-align: ${props.textAlign};
    `};

  ${props =>
    props.productPage &&
    css`
      margin: 0 0 7.5px;
      font-size: 28px !important;
      line-height: 1.25;
      @media screen and (min-width: 1180px) {
        font-size: 38px !important;
      }
    `};
  ${props =>
    props.productPageMoble &&
    css`
      margin: 0;
      font-size: 24px !important;
      line-height: 1.25;
    `};
`;

Heading.h1 = Heading;
Heading.h2 = Heading.withComponent('h2');
Heading.h3 = Heading.withComponent('h3');
Heading.h4 = Heading.withComponent('h4');
Heading.h5 = Heading.withComponent('h5');
Heading.h6 = Heading.withComponent('h6');
Heading.p = Heading.withComponent('p');



// WEBPACK FOOTER //
// ./src/styles/Heading.js